// Note for Angular2+:
// These may need to get rewritten in Angular2+ as Pipes or as Services since Angular2+
// does not have these AngularJS "Filter".

import * as angular from "angular";
import { PermissionCheck } from "./permission";
import { PermissionLevel } from "../utils/constants/permission-levels.constants";

let app = angular.module("filters", ["ngCookies"]);

app.filter("environment", (__env: any) => {
    return (key: string): any => {
        return __env[key];
    };
});

app.filter("productImage", (__env: any) => {
    return (url: string): string => {
        return "/img/" + __env.product + "/" + url;
    };
});

app.filter("isEmpty", () => {
    return (obj: object): boolean => {
        return angular.equals(obj, {});
    };
});

app.filter("numKeys", function () {
    return function (json) {
        let keys = Object.keys(json);
        return keys.length;
    };
});

app.filter("dateTime", () => {
    return (value?: string): number | string => {
        if (value == null) {
            return "";
        }
        value = value.replace(/-/g, "/");
        const valueDate = new Date(value);
        return valueDate.getTime();
    };
});

app.filter("localTime", () => {
    return (value?: number): number | string => {
        return value ? value - new Date().getTimezoneOffset() * 60 * 1000 : "";
    };
});

app.filter("round", () => {
    /* Use this $filter to round Numbers UP, DOWN and to his nearest neighbour.
           You can also use multiples */

    /* Usage Examples:
            - Round Nearest: {{ 4.4 | round }} // result is 4
            - Round Up: {{ 4.4 | round:'':'up' }} // result is 5
            - Round Down: {{ 4.6 | round:'':'down' }} // result is 4
            ** Multiples
            - Round by multiples of 10 {{ 5 | round:10 }} // result is 10
            - Round UP by multiples of 10 {{ 4 | round:10:'up' }} // result is 10
            - Round DOWN by multiples of 10 {{ 6 | round:10:'down' }} // result is 0
        */
    return (value?: any, mult?: any, dir?: any): number => {
        dir = dir || "nearest";
        mult = mult || 1;
        value = !value ? 0 : Number(value);
        if (dir === "up") {
            return Math.ceil(value / mult) * mult;
        } else if (dir === "down") {
            return Math.floor(value / mult) * mult;
        } else {
            return Math.round(value / mult) * mult;
        }
    };
});

app.filter("capitalize", () => {
    return (input: any, all: any): string => {
        let reg = all ? /([^\W_]+[^\s-]*) */g : /([^\W_]+[^\s-]*)/;
        return !!input
            ? input.replace(reg, (txt: string) => {
                  return (
                      txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
                  );
              })
            : "";
    };
});

app.filter("url", () => {
    return (input: string): string => {
        if (input) {
            const prefix = "http";
            if (input.substr(0, prefix.length) !== prefix) {
                return prefix + "://" + input;
            } else {
                return input;
            }
        }
    };
});

app.filter("capitalizeEachWord", () => {
    return (input?: string): string => {
        if (input) {
            if (input.indexOf(" ") !== -1) {
                input = input.toLowerCase();
                let inputPieces = input.split(" ");

                for (let i = 0; i < inputPieces.length; i++) {
                    inputPieces[i] = capitalizeString(inputPieces[i]);
                }

                return inputPieces.toString().replace(/,/g, " ");
            } else {
                input = input.toLowerCase();
                return capitalizeString(input);
            }
        }
    };
});
function capitalizeString(inputString: string): string {
    return inputString.substring(0, 1).toUpperCase() + inputString.substring(1);
}

app.filter("shortNumber", () => {
    return (number: number): string => {
        let abs = Math.abs(number);
        let shortNumber: string;
        if (abs >= Math.pow(10, 12)) {
            // trillion
            shortNumber = (number / Math.pow(10, 12)).toFixed(0) + "T";
        } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9)) {
            // billion
            shortNumber = (number / Math.pow(10, 9)).toFixed(0) + "B";
        } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6)) {
            // million
            shortNumber = (number / Math.pow(10, 6)).toFixed(0) + "M";
        } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3)) {
            // thousand
            shortNumber = (number / Math.pow(10, 3)).toFixed(0) + "k";
        }
        return shortNumber;
    };
});

app.filter("removeSpaces", () => {
    return (string: string | unknown): string | unknown => {
        return typeof string !== "string"
            ? string
            : string.replace(/[\s]/g, "");
    };
});

app.filter("stringReplace", () => {
    return (input?: string, from?: string, to?: string): string => {
        input = input || "";
        from = from || "";
        to = to || "";
        return input.replace(new RegExp(from, "g"), to);
    };
});

app.filter("parseUrl", () => {
    const urls =
        /(\b(https?|ftp):\/\/[A-Z0-9+&@#\/%?=~_|!:,.;-]*[-A-Z0-9+&@#\/%=~_|])/gim;
    const emails = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;

    return (text: string): string => {
        if (text.match(urls)) {
            text = text.replace(
                urls,
                '<a href="$1" class="md-primary" target="_blank">$1</a>'
            );
        }
        if (text.match(emails)) {
            text = text.replace(
                emails,
                '<a class="md-primary" href="mailto:$1">$1</a>'
            );
        }

        return text;
    };
});

app.filter("myCurrency", () => {
    return (input?: string): string => {
        if (input) {
            let inputNumber = parseFloat(input);

            if (inputNumber % 1 === 0) {
                input = inputNumber.toFixed(0);
            } else {
                input = inputNumber.toFixed(2);
            }

            return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
            return "";
        }
    };
});

app.filter("isValidEmail", () => {
    return (email: string): boolean => {
        const reg =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return reg.test(email);
    };
});

function creditCardBrand(ccnumber: string): string {
    if (!ccnumber) {
        return "";
    }
    let len = ccnumber.length;
    let cardType: string;
    let mul = 0;
    let prodArr = [
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        [0, 2, 4, 6, 8, 1, 3, 5, 7, 9],
    ];
    let sum = 0;

    while (len--) {
        sum += prodArr[mul][parseInt(ccnumber.charAt(len), 10)];
        mul ^= 1;
    }

    ccnumber = ccnumber.toString().replace(/\s+/g, "");

    if (/^(34)|^(37)/.test(ccnumber)) {
        cardType = "American Express";
    }
    if (/^(62)|^(88)/.test(ccnumber)) {
        cardType = "China UnionPay";
    }
    if (/^30[0-5]/.test(ccnumber)) {
        cardType = "Diners Club Carte Blanche";
    }
    if (/^(2014)|^(2149)/.test(ccnumber)) {
        cardType = "Diners Club enRoute";
    }
    if (/^36/.test(ccnumber)) {
        cardType = "Diners Club International";
    }
    if (
        /^(6011)|^(622(1(2[6-9]|[3-9][0-9])|[2-8][0-9]{2}|9([01][0-9]|2[0-5])))|^(64[4-9])|^65/.test(
            ccnumber
        )
    ) {
        cardType = "Discover Card";
    }
    if (/^35(2[89]|[3-8][0-9])/.test(ccnumber)) {
        cardType = "JCB";
    }
    if (/^(6304)|^(6706)|^(6771)|^(6709)/.test(ccnumber)) {
        cardType = "Laser";
    }
    if (
        /^(5018)|^(5020)|^(5038)|^(5893)|^(6304)|^(6759)|^(6761)|^(6762)|^(6763)|^(0604)/.test(
            ccnumber
        )
    ) {
        cardType = "Maestro";
    }
    if (/^5[1-5]/.test(ccnumber)) {
        cardType = "MasterCard";
    }
    if (/^4/.test(ccnumber)) {
        cardType = "Visa";
    }
    if (
        /^(4026)|^(417500)|^(4405)|^(4508)|^(4844)|^(4913)|^(4917)/.test(
            ccnumber
        )
    ) {
        cardType = "Visa Electron";
    }
    return cardType;
}

app.filter("cardBrand", () => {
    return (ccnumber: string): string => {
        return creditCardBrand(ccnumber);
    };
});

app.filter("currencySymbol", () => {
    return (input?: string): string => {
        if (!input) return "";

        if (input == "US" || input == "CA" || input == "MX") {
            return "$";
        } else if (input == "UK" || input == "GB") {
            return "£";
        } else {
            return "€";
        }
    };
});

app.filter("creditCardIcon", () => {
    return (cardType: string): string => {
        if (cardType == "Visa" || cardType == "visa") {
            return "/img/creditcards/visa.png";
        } else if (cardType == "MasterCard" || cardType == "mastercard") {
            return "/img/creditcards/mastercard.svg";
        } else if (
            cardType == "American Express" ||
            cardType == "american express" ||
            cardType == "amex"
        ) {
            return "/img/creditcards/amex.png";
        } else {
            return "/img/creditcards/generic.jpg";
        }
    };
});

app.filter("prettyDecimal", () => {
    return (decimal: number): number => {
        return decimal > 0 ? +(Math.round(Number(decimal + "e+2")) + "e-2") : 0;
    };
});

app.filter("htmlToPlaintext", () => {
    return (text: string): string => {
        return String(text).replace(/<[^>]+>/gm, "");
    };
});

app.filter("positive", () => {
    return (input?: number): number => {
        return input ? Math.abs(input) : 0;
    };
});

app.filter("unsafe", ($sce: any) => {
    return (val: any): any => {
        return $sce.trustAsHtml(val);
    };
});

app.filter("sanitizehtml", ($sce: any) => {
    return (htmlCode: any): any => {
        return $sce.trustAsHtml(htmlCode);
    };
});

app.filter("limitHtml", ($sce: any) => {
    return (htmlCode: any, limit: any): any => {
        return $sce.trustAsHtml(htmlCode.substring(0, limit));
    };
});

app.filter("dateSuffix", () => {
    return (d: number): string => {
        if (d > 3 && d < 21) return "th";
        switch (d % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    };
});

app.filter("true_false", () => {
    return (text: any): string | null => {
        if (text == 1 || text == true) {
            return "Yes";
        } else if (text == 0 || text == false) {
            return "No";
        } else {
            return null;
        }
    };
});

app.filter("pretty_location_type", () => {
    return (text: string): string => {
        if (text == "ROOFTOP") {
            return "Extremely Accurate";
        } else if (text == "RANGE_INTERPOLATED") {
            return "Very Accurate";
        } else if (text == "GEOMETRIC_CENTER") {
            return "Moderately Accurate";
        } else if (text == "APPROXIMATE") {
            return "Approximate";
        } else if (text == "Manual") {
            return "Manual (user input)";
        } else if (text == "GPS") {
            return "Phone GPS";
        } else if (text == "NationBuilder") {
            return "Nation Builder Import";
        } else if (text == "ZERO_RESULTS") {
            return "Unknown Location";
        } else {
            return "Pending";
        }
    };
});

app.filter("timeFormat", ($filter: any, PreferencesService: any) => {
    return (date: Date): string => {
        return $filter("date")(
            date,
            PreferencesService.use24Hour() ? "HH:mm" : "hh:mm a"
        );
    };
});

app.filter("niceDateTime", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let valueDate = getDateObject(value);

        const datePart = $filter("date")(valueDate, "MMM dd, yyyy");
        const timePart = $filter("timeFormat")(valueDate);

        return `${datePart} - ${timePart}`;
    };
});

app.filter("niceShortDateTime", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let valueDate = getDateObject(value);

        const datePart = $filter("date")(valueDate, "MMM dd");
        const timePart = $filter("timeFormat")(valueDate);

        return `${datePart} - ${timePart}`;
    };
});

app.filter("niceShortDateTimeFullMonth", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let valueDate = getDateObject(value);

        const datePart = $filter("date")(valueDate, "MMMM dd");
        const timePart = $filter("timeFormat")(valueDate);

        return `${datePart}, ${timePart}`;
    };
});

app.filter("niceShortDateTimeWithYear", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let valueDate = getDateObject(value);

        const datePart = $filter("date")(valueDate, "MMM dd, y");
        const timePart = $filter("timeFormat")(valueDate);

        return `${datePart} - ${timePart}`;
    };
});

app.filter("niceShortTime", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let valueDate = getDateObject(value);
        const timePart = $filter("timeFormat")(valueDate);

        return `${timePart}`;
    };
});

app.filter("niceDateTimeAt", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let valueDate = getDateObject(value);

        const datePart = $filter("date")(valueDate, "MMM dd, yyyy");
        const timePart = $filter("timeFormat")(valueDate);

        return `${datePart} at ${timePart}`;
    };
});

app.filter("niceDateTimeAtNoYear", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let valueDate = getDateObject(value);

        const day = getOrdinalNum($filter("date")(valueDate, "d"));

        const datePart = $filter("date")(valueDate, "MMM") + " " + day;
        const timePart = $filter("timeFormat")(valueDate);

        return `${datePart}, ${timePart}`;
    };
});

function getDateObject(value) {
    let valueDate;
    if (typeof value == "string") {
        value = value.replace(/-/g, "/");
        valueDate = new Date(value);
    } else {
        valueDate = value;
    }
    return valueDate;
}

function getOrdinalNum(n) {
    return (
        n +
        (n > 0
            ? ["th", "st", "nd", "rd"][
                  (n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10
              ]
            : "")
    );
}

app.filter("niceDate", ($filter: any) => {
    return (value?: string | Date): string => {
        if (!value) {
            return "";
        }
        let valueDate = null;
        if (!(value instanceof Date)) {
            value = value.replace(/-/g, "/");
            valueDate = new Date(value);
        } else {
            valueDate = angular.copy(value);
        }

        return $filter("date")(valueDate, "MMM dd, yyyy");
    };
});

app.filter("niceDateNoYear", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        value = value.replace(/-/g, "/");
        const valueDate = new Date(value);
        return $filter("date")(valueDate, "MMM dd");
    };
});

app.filter("wordedDate", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        value = value.replace(/-/g, "/");
        const valueDate = new Date(value);

        let _date = $filter("date")(valueDate, "MMMM d, y");
        let strTime = _date;

        return strTime;
    };
});

app.filter("hoursMinutes", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let hoursFloat = Number(value);
        let hours = Math.floor(hoursFloat);
        let fractionOfHour = hoursFloat - hours;
        let minutes = Math.round(fractionOfHour * 60);

        const hoursString = hours > 9 ? hours : "0" + hours;
        const minutesString = minutes > 9 ? minutes : "0" + minutes;

        return hoursString + ":" + minutesString;
    };
});

app.filter("hoursMinutesWords", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let hoursFloat = Number(value);
        let hours = Math.floor(hoursFloat);
        let fractionOfHour = hoursFloat - hours;
        let minutes = Math.round(fractionOfHour * 60);

        let returnString = "";

        if (hours > 0) {
            returnString += hours + "hrs ";
        }

        return returnString + minutes + "mins";
    };
});

app.filter("wordedShortDate", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        value = value.replace(/-/g, "/");
        const valueDate = new Date(value);

        let _date = $filter("date")(valueDate, "MMM d, y");
        let strTime = _date;

        return strTime;
    };
});

app.filter("wordedShortDateNoYear", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        value = value.replace(/-/g, "/");
        const valueDate = new Date(value);

        let _date = $filter("date")(valueDate, "MMMM d");
        let strTime = _date;

        return strTime;
    };
});

app.filter("niceExactDateTime", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let valueDate = getDateObject(value);

        const datePart = $filter("date")(valueDate, "MMMM d, y");
        const timePart = $filter("timeFormat")(valueDate);

        return `${datePart} - ${timePart}`;
    };
});

app.filter("nospace", () => {
    return (value?: string): string => {
        return !value ? "" : value.replace(/ /g, "");
    };
});

function getUTCtime(date: Date): number {
    return date.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
}

app.filter("timeago", ($interval: any) => {
    $interval(() => {}, 60000);

    function fromNowFilter(input: string): string {
        if (!input || angular.isUndefined(input)) {
            return null;
        }
        let date_string = input.replace(/-/g, "/");
        let nowDate = new Date();
        let nowTime = nowDate.setTime(nowDate.getTime());

        let substitute = (
                stringOrFunction: any,
                number: number,
                strings: any
            ): string => {
                let string = angular.isFunction(stringOrFunction)
                    ? stringOrFunction(number, dateDifference)
                    : stringOrFunction;
                let value =
                    (strings.numbers && strings.numbers[number]) || number;
                return string.replace(/%d/i, value);
            },
            date = new Date(date_string).getTime(),
            allowFuture = false,
            strings: any = {
                prefixAgo: "",
                prefixFromNow: "",
                suffixAgo: "ago",
                suffixFromNow: "from now",
                seconds: "less than a minute",
                minute: "a minute",
                minutes: "%d minutes",
                hour: "an hour",
                hours: "%d hours",
                day: "1 day",
                days: "%d days",
                month: "a month",
                months: "%d months",
                year: "a year",
                years: "%d years",
            },
            dateDifference = nowTime - date,
            words,
            seconds = Math.abs(dateDifference) / 1000,
            minutes = seconds / 60,
            hours = minutes / 60,
            days = hours / 24,
            years = days / 365,
            separator =
                strings.wordSeparator === undefined
                    ? " "
                    : strings.wordSeparator,
            prefix = strings.prefixAgo,
            suffix = strings.suffixAgo;

        if (allowFuture) {
            if (dateDifference < 0) {
                prefix = strings.prefixFromNow;
                suffix = strings.suffixFromNow;
            }
        }

        words =
            (seconds < 45 &&
                substitute(strings.seconds, Math.round(seconds), strings)) ||
            (seconds < 90 && substitute(strings.minute, 1, strings)) ||
            (minutes < 45 &&
                substitute(strings.minutes, Math.round(minutes), strings)) ||
            (minutes < 90 && substitute(strings.hour, 1, strings)) ||
            (hours < 24 &&
                substitute(strings.hours, Math.round(hours), strings)) ||
            (hours < 42 && substitute(strings.day, 1, strings)) ||
            (days < 30 &&
                substitute(strings.days, Math.round(days), strings)) ||
            (days < 45 && substitute(strings.month, 1, strings)) ||
            (days < 365 &&
                substitute(strings.months, Math.round(days / 30), strings)) ||
            (years < 1.5 && substitute(strings.year, 1, strings)) ||
            substitute(strings.years, Math.round(years), strings);
        prefix.replace(/ /g, "");
        words.replace(/ /g, "");
        suffix.replace(/ /g, "");
        return prefix + " " + words + " " + suffix + " " + separator;
    }

    fromNowFilter.$stateful = true;
    return fromNowFilter;
});

app.filter("lastsync", ($interval: any) => {
    $interval(() => {}, 60000);

    function fromNowFilter(input: string): string {
        if (!input || angular.isUndefined(input)) {
            return null;
        }
        let date_string = input.replace(/-/g, "/");
        let nowDate = new Date();
        let nowTime = nowDate.setTime(nowDate.getTime());

        let substitute = (
                stringOrFunction: any,
                number: number,
                strings: any
            ): string => {
                let string = angular.isFunction(stringOrFunction)
                    ? stringOrFunction(number, dateDifference)
                    : stringOrFunction;
                let value =
                    (strings.numbers && strings.numbers[number]) || number;
                return string.replace(/%d/i, value);
            },
            date = new Date(date_string).getTime(),
            allowFuture = false,
            strings: any = {
                prefixAgo: "",
                prefixFromNow: "",
                suffixAgo: "",
                suffixFromNow: "from now",
                seconds: "online",
                minute: "online",
                minutes: "%d mins",
                hour: "1 hour",
                hours: "%d hours",
                day: "1 day",
                days: "%d days",
                month: "1 month",
                months: "%d months",
                year: "1 year",
                years: "%d years",
            },
            dateDifference = nowTime - date,
            words,
            seconds = Math.abs(dateDifference) / 1000,
            minutes = seconds / 60,
            hours = minutes / 60,
            days = hours / 24,
            years = days / 365,
            separator =
                strings.wordSeparator === undefined
                    ? " "
                    : strings.wordSeparator,
            prefix = strings.prefixAgo,
            suffix = strings.suffixAgo;

        if (allowFuture) {
            if (dateDifference < 0) {
                prefix = strings.prefixFromNow;
                suffix = strings.suffixFromNow;
            }
        }

        if (minutes < 60) {
            return "online";
        }

        words =
            (seconds < 45 &&
                substitute(strings.seconds, Math.round(seconds), strings)) ||
            (seconds < 270 && substitute(strings.minute, 1, strings)) ||
            (minutes < 45 &&
                substitute(strings.minutes, Math.round(minutes), strings)) ||
            (minutes < 90 && substitute(strings.hour, 1, strings)) ||
            (hours < 24 &&
                substitute(strings.hours, Math.round(hours), strings)) ||
            (hours < 42 && substitute(strings.day, 1, strings)) ||
            (days < 30 &&
                substitute(strings.days, Math.round(days), strings)) ||
            (days < 45 && substitute(strings.month, 1, strings)) ||
            (days < 365 &&
                substitute(strings.months, Math.round(days / 30), strings)) ||
            (years < 1.5 && substitute(strings.year, 1, strings)) ||
            substitute(strings.years, Math.round(years), strings);
        prefix.replace(/ /g, "");
        words.replace(/ /g, "");
        suffix.replace(/ /g, "");
        return prefix + " " + words + " " + suffix + " " + separator;
    }

    fromNowFilter.$stateful = true;
    return fromNowFilter;
});

app.filter("ageFilter", () => {
    return (birthday: any): number => {
        let birthdayDate = new Date(birthday);
        let today = new Date();
        let age = (today.getTime() - birthdayDate.getTime()) / 31557600000;
        age = Math.floor(age);
        return age;
    };
});

app.filter("yearFilter", () => {
    return (birthYear: number): number => {
        let currentYear = new Date().getFullYear();
        return currentYear - birthYear;
    };
});

app.filter("logTime", ($filter: any) => {
    return (value?: string): string => {
        if (!value) {
            return "";
        }
        let valueDate = getDateObject(value);
        let year = valueDate.getFullYear();
        let currentYear = new Date().getFullYear();

        let _date;
        if (year != currentYear) {
            _date = $filter("date")(valueDate, "MMM dd yyyy");
        } else {
            _date = $filter("date")(valueDate, "MMM dd");
        }

        const timePart = $filter("timeFormat")(valueDate);

        return `${_date}, ${timePart}`;
    };
});

app.filter("highlight", ($sce: any) => {
    return (str: string, termsToHighlight: any): any => {
        // Sort terms by length
        termsToHighlight.sort((a: any, b: any) => {
            return b.length - a.length;
        });
        // Regex to simultaneously replace terms
        let regex = new RegExp("(" + termsToHighlight.join("|") + ")", "ig");
        return $sce.trustAsHtml(
            str.replace(regex, '<span class="match">$&</span>')
        );
    };
});

app.filter("permissionName", [
    "PermissionCheck",
    function (PermissionCheck: PermissionCheck) {
        return function (permissionid: number | string): string {
            if (permissionid == 1) {
                // ecanvasser admin account
                return "admin";
            }
            const level: PermissionLevel =
                PermissionCheck.getPermission(permissionid);
            return level ? level.permissionname : String(permissionid || "");
        };
    },
]);
